import { render, staticRenderFns } from "./page_size_selector.vue?vue&type=template&id=28c3d0ea"
import script from "./page_size_selector.vue?vue&type=script&lang=js"
export * from "./page_size_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports